import request from '@/utils/request'

// 综合数据查询 
export function getSynthesizeDateView(query) {
    return request({
        url: '/front/dataView/getSynthesizeDateView',
        method: 'get',
        params: query
    })
}

// 组织机构数据查询 
export function getOrganDateView(query) {
    return request({
        url: '/front/dataView/getOrganDateView',
        method: 'get',
        params: query
    })
}

// 用户增长/活跃统计数据查询 
export function getUserDateView(query) {
    return request({
        url: '/front/dataView/getUserDateView',
        method: 'get',
        params: query
    })
}
// 用户增长/活跃统计数据查询 
export function getResourceTypeDateView(query) {
    return request({
        url: '/front/dataView/getResourceTypeDateView',
        method: 'get',
        params: query
    })
}

// 课程学习人数占比统计查询 
export function getCourceStudyDateView(query) {
    return request({
        url: '/front/dataView/getCourceStudyDateView',
        method: 'get',
        params: query
    })
}


// 课程学习人数占比统计查询 
export function getVirtualImitationDateView(query) {
    return request({
        url: '/front/dataView/getVirtualImitationDateView',
        method: 'get',
        params: query
    })
}


// 在线虚仿实时详情
export function getVirtualImitationOperateDateView(query) {
    return request({
        url: '/front/dataView/getVirtualImitationOperateDateView',
        method: 'get',
        params: query
    })
}